import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import traduções pt-BR
import ptBRCommon from './locales/pt-BR/common.json';
import ptBRAuth from './locales/pt-BR/auth.json';
import ptBRLanding from './locales/pt-BR/landing.json';
import ptBRProfile from './locales/pt-BR/profile.json';
import ptBRManual from './locales/pt-BR/manual.json';

// Import traduções en
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enLanding from './locales/en/landing.json';
import enProfile from './locales/en/profile.json';
import enManual from './locales/en/manual.json';

// Import traduções es
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esLanding from './locales/es/landing.json';
import esProfile from './locales/es/profile.json';
import esManual from './locales/es/manual.json';

const resources = {
  'pt-BR': {
    common: ptBRCommon,
    auth: ptBRAuth,
    landing: ptBRLanding,
    profile: ptBRProfile,
    manual: ptBRManual,
  },
  'en': {
    common: enCommon,
    auth: enAuth,
    landing: enLanding,
    profile: enProfile,
    manual: enManual,
  },
  'es': {
    common: esCommon,
    auth: esAuth,
    landing: esLanding,
    profile: esProfile,
    manual: esManual,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    
    interpolation: {
      escapeValue: false,
    },
    
    debug: false,
    
    supportedLngs: ['pt-BR', 'en', 'es'],
  });

export default i18n;
